export default __webpack_public_path__ + "static/media/tick.887b83be.gif";